const state = {
  report_basic: [],
  report_moneybox_unload_state: [],
  overdue_moneyboxes: [],
  data_quality: null,
  segment_breakdown: [],
  unload_trend: [],
  user_performance: [],
}

const getters = {

}

const actions = {
  requestReportBasic({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.get(api.reportsBasic()).then(function(response){
                  commit("_requestReportBasic", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestReportMoneyboxUnloadState({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.get(api.reportsMoneyboxUnloadState()).then(function(response){
                  commit("_requestReportMoneyboxUnloadState", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestOverdueMoneyboxes({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {
      this._vm.$axios.get(api.reportsOverdueMoneyboxes()).then(function(response){
                  commit("_requestOverdueMoneyboxes", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestDataQuality({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {
      this._vm.$axios.get(api.reportsDataQuality()).then(function(response){
                  commit("_requestDataQuality", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestSegmentBreakdown({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {
      this._vm.$axios.get(api.reportsSegmentBreakdown()).then(function(response){
                  commit("_requestSegmentBreakdown", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestUnloadTrend({commit}, granularity){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {
      this._vm.$axios.get(api.reportsUnloadTrend(granularity)).then(function(response){
                  commit("_requestUnloadTrend", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestUserPerformance({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {
      this._vm.$axios.get(api.reportsUserPerformance()).then(function(response){
                  commit("_requestUserPerformance", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
}

const mutations = {
  _requestReportBasic(state, payload){
    state.report_basic = payload
  },
  _requestReportMoneyboxUnloadState(state, payload){
    state.report_moneybox_unload_state = payload
  },
  _requestOverdueMoneyboxes(state, payload){
    state.overdue_moneyboxes = payload
  },
  _requestDataQuality(state, payload){
    state.data_quality = payload
  },
  _requestSegmentBreakdown(state, payload){
    state.segment_breakdown = payload
  },
  _requestUnloadTrend(state, payload){
    state.unload_trend = payload
  },
  _requestUserPerformance(state, payload){
    state.user_performance = payload
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
